export default __webpack_public_path__ + "static/media/calendar-arrow-back-double.29fdf715.svg";